import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-dashboard-empty-no-project',
  imports: [TranslatePipe],
  templateUrl: './dashboard-empty-no-project.component.html',
  styleUrl: './dashboard-empty.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardEmptyNoProjectComponent {}
